import React from 'react';
import LabelFormMyPage from 'page/Application/MyPage/component/FormMyPage/LabelFormMyPage';
import { FormValidateTextAndNumber } from 'components/Form2';
import {
  GridFormAccount,
  GridFormAccount1to2,
  GridFormAccount2to3,
} from 'page/Application/MyPagePartnerAdmin/styled';
import useMultiLanguageRegisterAccount from 'page/Application/ManageAccountSoliton/RegisterAccountSoliton/hook/useMultiLanguageRegisterAccount';

const Department = ({ editMode }) => {
  const { REGISTER_ACCOUNT_PLACEHOLDER_DEPARTMENT } =
    useMultiLanguageRegisterAccount();

  return (
    <GridFormAccount>
      <GridFormAccount1to2>
        <LabelFormMyPage labelText={'部署'} />
      </GridFormAccount1to2>
      <GridFormAccount2to3>
        <FormValidateTextAndNumber
          name="department"
          required={false}
          placeholder={editMode && REGISTER_ACCOUNT_PLACEHOLDER_DEPARTMENT}
        />
      </GridFormAccount2to3>
    </GridFormAccount>
  );
};

export default Department;
